import {
  IonCol,
  IonGrid,
  IonItem,
  IonList,
  IonRow,
  IonBadge,
} from "@ionic/react";
import React from "react";

import {
  ICommentNotification,
  IConversationNotification,
  IFeedbackNotification,
} from "../../state";
import { simpleDateTimeStr } from "../../libs/Util";
import { realizationDetailPath } from "../../store/student";

import styles from "./CommentNotifications.module.scss";

const getNotificationMessage = (
  type: string,
  commentorName: string | null,
): string => {
  switch (type) {
    case "feedback":
      return commentorName
        ? `${commentorName} さんがフィードバックしました`
        : "フィードバックが追加されました";
    case "comment":
      return commentorName
        ? `${commentorName} さんがコメントしました`
        : "コメントが追加されました";
    default:
      return "GEARから返信がきています";
  }
};

export interface CommentNotificationsProps {
  commentNotifications: ICommentNotification[];
  conversationNotifications?: IConversationNotification[];
  feedbackNotifications?: IFeedbackNotification[];
}

const CommentNotifications: React.FC<CommentNotificationsProps> = ({
  commentNotifications,
  conversationNotifications = [],
  feedbackNotifications = [],
}) => {
  const allNotifications = [
    ...commentNotifications.map(notification => ({
      type: "comment" as const,
      ...notification,
    })),
    ...conversationNotifications.map(notification => ({
      type: "conversation" as const,
      ...notification,
    })),
    ...feedbackNotifications.map(notification => ({
      type: "feedback" as const,
      ...notification,
    })),
  ].sort((a, b) => b.created_at.getTime() - a.created_at.getTime());

  return (
    <div className={styles.wrapper}>
      <IonList className={styles.wrapper}>
        {allNotifications.length ? (
          allNotifications.map((notification, index) => {
            const { unread_count, content, created_at, realization, type } =
              notification;

            const commentor_name =
              type === "comment" || type === "feedback"
                ? (
                    notification as typeof notification & {
                      type: "comment" | "feedback";
                    }
                  ).commentor_name
                : null;

            return (
              <IonItem
                key={`${type}-${index}`}
                routerLink={`${realizationDetailPath}/${realization.id}`}
                className={styles.item}
              >
                <IonGrid className={styles.grid}>
                  <IonRow>
                    <IonCol size="12">
                      <div className={styles.content}>
                        <span>
                          {getNotificationMessage(type, commentor_name)}
                        </span>
                        {unread_count > 1 && (
                          <IonBadge color="danger">
                            他{unread_count - 1}件
                          </IonBadge>
                        )}
                      </div>
                    </IonCol>
                    <IonCol size="12">
                      <div className={styles.footer}>
                        <span>{content}</span>
                        <span>{simpleDateTimeStr(created_at)}</span>
                      </div>
                    </IonCol>
                  </IonRow>
                </IonGrid>
              </IonItem>
            );
          })
        ) : (
          <p className={styles.emptyData}>通知はありません。</p>
        )}
      </IonList>
    </div>
  );
};

export default CommentNotifications;
